export const zhCN_globalTips = {
  'global.tips.notfound': '对不起，您访问的页面不存在。',
  'global.tips.unauthorized': '对不起，您没有权限访问此页。',
  'global.tips.loginResult': '看到此页面代表您已登录。',
  'global.tips.goToLogin': '去登录',
  'global.tips.login': '登录',
  'global.tips.username': '用户名',
  'global.tips.enterUsernameMessage': '请输入用户名！',
  'global.tips.password': '密码',
  'global.tips.enterPasswordMessage': '请输入密码！',
  'global.tips.rememberUser': '记住用户',
  'global.tips.backHome': '返回首页',
  'global.tips.operation': '操作',
  'global.tips.authorize': '授权',
  'global.tips.delete': '删除',
  'global.tips.create': '新建',
  'global.tips.modify': '修改',
  'global.tips.search': '搜索',
  'global.tips.reset': '重置',
  'global.tips.deleteConfirm': '确定要删除此条数据吗？',
  'global.tips.loading': '加载中...',
  'global.tips.theme.darkTooltip': '切换至深色主题',
  'global.tips.theme.lightTooltip': '切换至浅色主题',
  'global.tips.theme.noticeTooltip': '通知'
};
